const getCookieVal = (offset) => {
  let endstr = document.cookie.indexOf(';', offset);
  if (endstr === -1) {
    endstr = document.cookie.length;
  }
  return unescape(document.cookie.substring(offset, endstr));
};

export const createCookieMaxAge = (days = 0, hours = 0, minutes = 0, seconds = 0) => ((days * 86400) + (hours * 3600) + (minutes * 60) + seconds);

export const getCookie = (name) => {
  const arg = `${name}=`;
  const alen = arg.length;
  const clen = document.cookie.length;

  let i = 0;
  while (i < clen) {
    const j = i + alen;
    if (document.cookie.substring(i, j) === arg) {
      return getCookieVal(j);
    }
    i = document.cookie.indexOf(' ', i) + 1;
    if (i === 0) break;
  }
  return null;
};

export const existsCookie = (name) => (getCookie(name) !== null);

export const addCookie = (name, value, maxAgeSeconds = 0, sameSite = 'Lax') => {
  document.cookie = `${name}=${escape(value)} ${(maxAgeSeconds === 0) ? '' : `; max-age=${maxAgeSeconds}`}; path=/; SameSite=${sameSite}; secure`;
};

export const removeCookie = (name) => {
  if (getCookie(name)) {
    document.cookie = `${name}=; expires=Thu, 01-Jan-70 00:00:01 GMT`;
  }
};
